import {SubmitState} from "./SubmitState";

export interface ChoiceAggregationResult {
    state: SubmitState
    attributes: Attr
}
